export enum Language {
    ZH_CN = "zh-CN",
    EN_US = "en-US",
    ZH_TW = "zh-TW"
}

export enum LifeCycleStatus {
    ENABLED = "ENABLED",
    DISABLED = "DISABLED",
    DRAFT = "DRAFT"
}

export enum YesOrNO {
    YES = "YES",
    NO = "NO"
}

export enum Gender {
    MALE = "MALE",
    FEMALE = "FEMALE"
}

export enum HouseholdType {
    TOWN = "TOWN",
    RURAL = "RURAL"
}

export enum IdentityType {
    ID_CARD = "ID_CARD",
    OFFICERS = "OFFICERS",
    HK_SAR_PASSPORT = "HK_SAR_PASSPORT",
    MACAO_SAR_PASSPORT = "MACAO_SAR_PASSPORT",
    TAIWAN_TO_MAINLAND_PASS_CHECK = "TAIWAN_TO_MAINLAND_PASS_CHECK",
    PASSPORT = "PASSPORT",
    OVERSEAS_PERMANENT_RESIDENCE_PERMIT = "OVERSEAS_PERMANENT_RESIDENCE_PERMIT",
    CRIMINAL_ID = "CRIMINAL_ID"
}

export enum PoliticalAffiliationType {
    PARTY_MEMBER = "PARTY_MEMBER",
    LEAGUE_MEMBER = "LEAGUE_MEMBER",
    MASS = "MASS",
    OTHER = "OTHER"
}

export enum EthnicityType {
    HZ = "HZ",
    MGZ = "MGZ",
    HUZ = "HUZ",
    ZZ = "ZZ",
    WWEZ = "WWEZ",
    MIZ = "MIZ",
    YIZ = "YIZ",
    ZHZ = "ZHZ",
    BYZ = "BYZ",
    CXZ = "CXZ",
    MZ = "MZ",
    DOZ = "DOZ",
    YZ = "YZ",
    BZ = "BZ",
    TJZ = "TJZ",
    HNZ = "HNZ",
    HSKZ = "HSKZ",
    DZ = "DZ",
    LZ = "LZ",
    LSZ = "LSZ",
    WZ = "WZ",
    SHEZ = "SHEZ",
    GSZ = "GSZ",
    LH = "LH",
    SHZ = "SHZ",
    DXZ = "DXZ",
    NXZ = "NXZ",
    JPZ = "JPZ",
    KEKZZ = "KEKZZ",
    TZ = "TZ",
    DWEZ = "DWEZ",
    MLZ = "MLZ",
    QZ = "QZ",
    BLZ = "BLZ",
    SLZ = "SLZ",
    MNZ = "MNZ",
    GLZ = "GLZ",
    XBZ = "XBZ",
    ACZ = "ACZ",
    PMZ = "PMZ",
    TJZZ = "TJZZ",
    NZ = "NZ",
    WZBKZ = "WZBKZ",
    ELSZ = "ELSZ",
    EWKZ = "EWKZ",
    DAZ = "DAZ",
    BAZ = "BAZ",
    YGZ = "YGZ",
    JZ = "JZ",
    TTEZ = "TTEZ",
    DLZ = "DLZ",
    ELCZ = "ELCZ",
    HZZ = "HZZ",
    MBZ = "MBZ",
    LBZ = "LBZ",
    JNZ = "JNZ"
}

export enum StorageBusinessType {
    USER = "USER",
    ENROLLMENT = "ENROLLMENT",
    ENROLLMENT_USER = "ENROLLMENT_USER"
}

export enum OccupationLevel {
    NONE = "NONE",
    LEVEL_1 = "LEVEL_1",
    LEVEL_2 = "LEVEL_2",
    LEVEL_3 = "LEVEL_3",
    LEVEL_4 = "LEVEL_4",
    LEVEL_5 = "LEVEL_5"
}

export enum CertificateType {
    FORENSICS = "FORENSICS",
    NON_FORENSICS = "NON_FORENSICS"
}

export enum PublishStatus {
    PUBLISHED = "PUBLISHED",
    UNPUBLISHED = "UNPUBLISHED",
    CANCELLED = "CANCELLED"
}

export enum RegistrationStatus {
    NOT_STARTED = "NOT_STARTED",
    PROCESSING = "PROCESSING",
    ENDED = "ENDED"
}

export enum OpenKlassStatus {
    UN_OPEN = "UN_OPEN",
    OPENED = "OPENED"
}

export enum KlassStatus {
    NOT_STARTED = "NOT_STARTED",
    IN_PROGRESS = "IN_PROGRESS",
    ENDED = "ENDED"
}

export enum ApprovalStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED"
}

export enum PaymentStatus {
    PAY_PENDING = "PAY_PENDING",
    PAY_SUCCESS = "PAY_SUCCESS",
    REFUND_PENDING = "REFUND_PENDING",
    REFUND_SUCCESS = "REFUND_SUCCESS"
}

export enum TrainType {
    THEORY = "THEORY",
    PRACTICE = "PRACTICE",
    ALL = "ALL",
    OTHER = "OTHER"
}

export enum GraduationStatus {
    UN_GRADUATED = "UN_GRADUATED",
    GRADUATED = "GRADUATED",
    DELAY_GRADUATED = "DELAY_GRADUATED",
    NON_COMPLETION = "NON_COMPLETION"
}

export enum CertificateStatus {
    ISSUED = "ISSUED",
    UNISSUED = "UNISSUED"
}

export enum ExamineeSource {
    SOCIETY = "SOCIETY",
    ENTERPRISE = "ENTERPRISE",
    COLLEGE = "COLLEGE",
    ARMY = "ARMY",
    GRADUATE = "GRADUATE",
    PRISONER = "PRISONER",
    OFFICE = "OFFICE",
    STATE_INSTITUTION = "STATE_INSTITUTION",
    DISABLED = "DISABLED",
    NEW_JOB = "NEW_JOB",
    CBT = "CBT",
    TECHNICIAN = "TECHNICIAN",
    SPECIAL_WORK = "SPECIAL_WORK",
    EVALUATION_PILOT = "EVALUATION_PILOT",
    LOCAL_FARMER = "LOCAL_FARMER",
    UNEMPLOYED = "UNEMPLOYED"
}

export enum PersonnelType {
    STAFF = "STAFF",
    STUDENT = "STUDENT",
    UNEMPLOYEE = "UNEMPLOYEE",
    RURAL_LABOR = "RURAL_LABOR"
}

export enum HighestEducation {
    NONE = "NONE",
    PRIMARY_SCHOOL = "PRIMARY_SCHOOL",
    JUNIOR_HIGH_SCHOOL = "JUNIOR_HIGH_SCHOOL",
    TECHNICAL_SECONDARY_SCHOOL = "TECHNICAL_SECONDARY_SCHOOL",
    TECHNICAL_SCHOOL = "TECHNICAL_SCHOOL",
    SENIOR_SCHOOL = "SENIOR_SCHOOL",
    HIGHT_TECHNICAL_SCHOOL = "HIGHT_TECHNICAL_SCHOOL",
    PROFESSIONAL_HIGH_SCHOOL = "PROFESSIONAL_HIGH_SCHOOL",
    FACHSCHULE = "FACHSCHULE",
    HIGHER_VOCATIONAL = "HIGHER_VOCATIONAL",
    JUNIOR_COLLEGE = "JUNIOR_COLLEGE",
    UNDERGRADUATE = "UNDERGRADUATE",
    MASTER = "MASTER",
    DOCTOR = "DOCTOR"
}

export enum FundingSource {
    SCHOLARSHIP = "SCHOLARSHIP",
    SELF_SUPPORTING = "SELF_SUPPORTING",
    OTHER = "OTHER"
}

export enum HighestDegree {
    NONE = "NONE",
    BACHELOR = "BACHELOR",
    MASTER = "MASTER",
    DOCTOR = "DOCTOR"
}

export enum AttachmentCode {
    ID_CARD = "id-card",
    ID_CARD_BACK = "id-card-back",
    ID_PHOTO = "id-photo",
    EDU_CERT = "edu-cert",
    USER_AVATAR = "user-avatar"
}

export enum PrefixFileName {
    STUDENT_PHOTOS = "student-photos",
    PLAN_COVER = "plan-cover"
}

export enum RegistrationType {
    PERSONAL = "PERSONAL",
    GROUP = "GROUP"
}

export enum Roles {
    ADMIN = "ADMIN",
    ENROLLMENT_ADMIN = "ENROLLMENT_ADMIN",
    FINANCE = "FINANCE",
    FACULTY = "FACULTY",
    STUDENT = "STUDENT"
}

export enum FilterTypes {
    ORG = "ORG",
    CLASSIFICATIONS = "CLASSIFICATIONS",
    OCCUPATIONS = "OCCUPATIONS",
    LEVELS = "LEVELS",
    CERTIFICATE_TYPES = "CERTIFICATE_TYPES",
    REGISTRATION_STATUS = "REGISTRATION_STATUS",
    SORT_KEY = "SORT_KEY"
}

export enum NationalityType {
    DOMESTIC = "DOMESTIC",
    FOREIGN = "FOREIGN"
}

export enum MaritalType {
    SINGLE = "SINGLE",
    MARRIED = "MARRIED"
}
